import axios from "axios";
const jsonConfig = require("../../Config.json");


const getAllRequitionForCandidates = async (payload_data) => {
 
  try {

    const getAllResponse = await axios.post(
      `${jsonConfig.apiUrl}getCandidateActivity`, payload_data,
      {
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return Promise.resolve(getAllResponse);
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getAllRequitionForCandidates;

